import React from 'react';
import NavPanel from './NavPanel';
import Topbar from './Topbar';

function Header() {
    return (
        <div className="site-header">
          <Topbar />
            <div className="site-header__nav-panel">
                <NavPanel layout="default" />
            </div>
        </div>
    );
}

export default Header;
